import React, { useEffect, useState } from "react"
import {
  BadgeStatus,
  NoteView,
  TableSkeleton,
  TableView
} from "../../../../../../component/index.jsx"
import { getListAreaBlock } from "../../../../../../redux/actions/AreaAction.jsx"
import { useDispatch, useSelector } from "react-redux"
import { formatterRowComponent } from "../../../../../../component/atoms/Tabel/index.jsx"
import { sortCaret } from "../../../../../../_metronic/_helpers/index.js"
import { Card, OverlayTrigger, Tooltip } from "react-bootstrap"
import { RoutesConstants } from "../../../../../../constants/RoutesConstants.js"
import { DetailSvgIcon } from "../../../../../../component/atoms/Icons/SVG/index.jsx"
import {
  AREA_REGISTERED_ENUM,
  DATE_TYPE_ENUM,
  INSPECTION_STATUS_ENUM,
  INSPECTION_STATUS_STRING,
  ROUTING_STATUS,
  UNIT_STRING
} from "../../../../../../constants/StringConstant.js"
import { useTranslation } from "react-i18next"
import {
  stringFormatting,
  convertDotToComma,
  convertM2ToHectare
} from "../../../../../helpers/TextHelper.js"
import { timeStampToDate } from "../../../../../helpers/DateHelper.js"
import { CardBody } from "../../../../../../_metronic/_partials/controls/index.js"

export const ListAreaTab = ({ history, id, status }) => {
  const { Area, General } = useSelector((state) => state)
  const { t } = useTranslation()
  const [data, setData] = useState([])
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getListAreaBlock(id))
  }, [])

  useEffect(() => {
    if (Area.listAreaBlock) {
      setData(Area.listAreaBlock)
    }
  }, [Area])

  function checkBadgeColor(status) {
    switch (status) {
      case INSPECTION_STATUS_ENUM.PASS:
        return "success"
      case INSPECTION_STATUS_ENUM.NOT_PASS:
        return "danger"
      case INSPECTION_STATUS_ENUM.PARTIAL_PASS:
        return "warning"
      case INSPECTION_STATUS_ENUM.LAND_CLEARING:
        return "light"
    }
  }

  function uiCode(e) {
    return (
      <>
        <div className={"text-dark font-weight-bolder  font-size-lg"}>
          {stringFormatting(e?.area_name)}
        </div>
      </>
    )
  }

  function uiFarmer(e) {
    return (
      <div>
        <div className={"text-dark font-weight-bolder  font-size-lg mb-1"}>
          {stringFormatting(e?.farmer_name)}
        </div>
        <div>{stringFormatting(e?.farmer_phone)}</div>
      </div>
    )
  }

  function uiArea(e) {
    return (
      <div>
        <div className={"text-dark font-weight-bolder  font-size-lg mb-1"}>
          {convertDotToComma(convertM2ToHectare(e?.land_area, 4), UNIT_STRING.HA)}
        </div>
      </div>
    )
  }

  function uiPlantingDate(e) {
    return (
      <div>
        <div className={"text-dark font-weight-bolder  font-size-lg mb-1"}>
          {stringFormatting(timeStampToDate(e?.planting_date, DATE_TYPE_ENUM.ISO_DATE_STRAP))}
        </div>
        <div>{stringFormatting(e?.hst, "HST")}</div>
      </div>
    )
  }

  function uiInspectionStatus(e) {
    return (
      <div>
        {e?.inspection_status_enum && (
          <BadgeStatus
            className={"w-130px"}
            variant={checkBadgeColor(e?.inspection_status_enum)}
            status={INSPECTION_STATUS_STRING[e?.inspection_status_enum]}
          />
        )}
      </div>
    )
  }

  const uiAction = (e) => {
    return (
      <div>
        <OverlayTrigger overlay={<Tooltip id="products-detail-tooltip">Detail</Tooltip>}>
          <div
            onClick={() => {
              history.push(
                RoutesConstants.AREA.DETAIL_AREA(AREA_REGISTERED_ENUM.MT_ACTIVE, e?.id)
              )
            }}
            className={"btn btn-icon btn-list btn-hover-secondary btn-sm mx-3"}>
            <DetailSvgIcon />
          </div>
        </OverlayTrigger>
      </div>
    )
  }

  const columns = [
    {
      dataField: "code",
      text: t("table_header_area_name"),
      sort: true,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiCode
      },
      headerStyle: () => {
        return { width: "15%" }
      },
      sortCaret: sortCaret
    },
    {
      dataField: "farmer",
      text: t("table_header_farmer"),
      sort: true,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiFarmer
      },
      sortCaret: sortCaret
    },
    {
      dataField: "totalAreaLand",
      text: t("table_header_area"),
      sort: true,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiArea
      },
      sortCaret: sortCaret
    },
    {
      dataField: "lastActivityDate",
      text: t("table_header_planting_date"),
      sort: true,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiPlantingDate
      },
      sortCaret: sortCaret
    },
    {
      dataField: "status",
      text: t("table_header_inspection_status"),
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiInspectionStatus
      }
    },
    {
      dataField: "action",
      text: "ACTION",
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiAction
      }
    }
  ]

  return (
    <Card className={"mb-4"}>
      <CardBody>
        {General?.loading ? (
          <TableSkeleton column={6} row={6} />
        ) : (
          <>
            {status === ROUTING_STATUS.BLOCK_STATUS_STRING.HISTORY && (
              <NoteView variant={"info"} title={t(`messages_alert_non_active_block_info`)} />
            )}
            <TableView
              dataTable={data || []}
              columnProperties={columns}
              loadingGetData={false}
              callbackAfterPageChange={() => {}}
              keyField={"id"}
              disablePagination
            />
          </>
        )}
      </CardBody>
    </Card>
  )
}